@if (loader.visible()) {
  <div class="journey-loader" role="status" aria-live="assertive">
    <img
      class="journey-loader__art"
      [src]="artSrc"
      [alt]="'lup.lu_dashboard.widgets.dynamic_journey_modal.loading_title' | translate" />
  </div>
}
